import {
  checkUsernameExists,
  checkUserEmailExists
} from "./profile.service";

export function validateUsername(username) {
  const errors = {};

  if (!username) {
    errors.username = "Enter a username";
  }

  return errors;
}

export function validateEmail(values) {
  const errors = {};

  if (!values.email) {
    errors.username = "Enter an email";
  }

  return errors;
}

export function validatePassword(password, key = 'password') {
  const errors = {};

  if (!password) {
    errors[key] = "Enter a password";
  }

  if (password && password.length < 8) {
    errors[key] = "Password must be longer than 8 characters";
  }

  if (password && !/\d/.test(password)) {
    errors[key] = "Password must contain at least one number";
  }

  if (password && !/[a-zA-Z]/.test(password)) {
    errors[key] = "Password must contain at least one letter";
  }

  return errors;
}

export const asyncValidateUsername = ({ username }) => {
  return checkUsernameExists(username).then(({ data }) => {
    if(data.exists) {
      throw { username: "Username already exists"}
    }
  });
};

export const asyncValidateEmail = ({ email }) => {
  return checkUserEmailExists(email).then(({ data }) => {
    if(data.exists) {
      throw { email: "Email already exists"}
    }
  });
};


// WEBPACK FOOTER //
// ./src/services/validation.js